// 確保瀏覽器帶有 xsrf-token cookie：各 Request 實例會透過 xsrfCookieName 讀取此 cookie，
// 並於請求時自動帶上 xsrf-token header。於 App 啟動時呼叫一次即可。
import { getCookie, setCookie } from '../../utils/cookie';

// 產生亂數字串作為 xsrf-token 的值
function generateRandomString(num) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = ' ';
  const charactersLength = characters.length;
  for (let i = 0; i < num; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// 若尚未有 xsrf-token cookie，產生一組（32 碼）session cookie 並寫入。
// 沿用原本以 NODE_ENV 判斷是否綁定跨網域（與 auth 的 VUE_APP_ENV 判斷不同，維持原行為）。
export function ensureXsrfToken() {
  if (getCookie('xsrf-token')) return;
  setCookie('xsrf-token', generateRandomString(32), { crossSite: process.env.NODE_ENV === 'production' });
}
